// 押下ボタン自身の送信かを判定する。Turbo は data-turbo-method のリンクを、href を絶対URLに展開して
// action に持つフォームとして送信するため、パスを照らして他フォームの送信完了と区別する。
// href が取得できない場合は区別できないため、直近の送信完了を自身の送信として扱う。
const isSubmissionOf = (submitEvent: Event, button: Element): boolean => {
  const form = submitEvent.target
  const href = button.getAttribute('href')
  if (!href || !(form instanceof HTMLFormElement)) return true

  const path = (url: string) => new URL(url, document.baseURI).pathname

  return path(form.action) === path(href)
}

// 閉じるボタン押下時に、押されたボタンが属する要素だけをリロードなしで非表示にする。
// 押されたボタン起点でスコープするため、同種のボタンが複数表示されていても他の要素は閉じない。
// Turboによる送信完了（turbo:submit-end）を待ち、成功した場合のみ非表示にする。
export const hideAncestorOnSuccess = (buttonSelector: string, ancestorSelector: string): void => {
  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return

    const button = event.target.closest(buttonSelector)
    if (!button) return

    const handleSubmitEnd = (submitEvent: Event) => {
      if (!isSubmissionOf(submitEvent, button)) return

      document.removeEventListener('turbo:submit-end', handleSubmitEnd)
      if (!(submitEvent as CustomEvent).detail.success) return

      const ancestor = button.closest(ancestorSelector) as HTMLElement
      if (ancestor) {
        ancestor.style.display = 'none'
      }
    }

    document.addEventListener('turbo:submit-end', handleSubmitEnd)
  })
}
